// ANTS_ENABLED
$(() => {
  if (window.user_id) {
    return axios.get(`/xhr/ants-enabled?user_id=${window.user_id}`)
      .then(response => {
        window.ANTS_ENABLED = response.data;
      })
      .catch(error => {
        console.error('error', error);
      });
    // TODO:
    // window.ANTS_ENABLED = await axios.get('/xhr/ants-enabled').catch((err) => {
    //   console.log('err', err);
    // });
    // console.error('window.ANTS_ENABLED', window.ANTS_ENABLED)
  }
})